import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

// lang
import "./i18n/I18next.js";

// toast
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import App from "./App.jsx";
import { HelmetProvider } from "react-helmet-async";

// // primereact
// import "primereact/resources/themes/tailwind-light/theme.css";
// // import "primeicons/primeicons.css";

// // styles
// import "./assets/styles/config/tailwind_config.css";
// import "./assets/styles/config/style.css";

createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <HelmetProvider>
      <App />
    </HelmetProvider>
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      pauseOnHover
      theme="light"
    />
  </BrowserRouter>,
);
